import { Link, useLocation } from "react-router-dom";
import { PlusSquare, User, Globe, LogOut, Compass, MessageCircle } from "lucide-react";
import { useToast } from "@/hooks/use-toast";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Hey from "@/lib/hey-utils";
import { trackNavigation, trackHeaderAction } from "@/utils/analytics";
import { Button } from "@/components/ui/button";
import { HeyUtils } from "@/lib/hey/core";
const DesktopSidebar = () => {
  const location = useLocation();
  const {
    toast
  } = useToast();
  const navigate = useNavigate();
  const {
    t
  } = useTranslation();
  const isActive = (path: string) => location.pathname === path;
  const handleSignOut = async () => {
    trackHeaderAction("sign_out", "desktop");
    try {
      if (await Hey.HeyUtils.getInstance().signOut()) {
        toast({
          title: t("common.toast.success"),
          description: t("auth.signOutSuccessful", "Signed out successfully")
        });
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
    } catch (error) {
      toast({
        variant: "destructive",
        title: t("common.toast.error"),
        description: t("auth.signOutError", "An error occurred while signing out.")
      });
    }
  };
  const handleNavClick = (destination: string) => {
    trackNavigation(destination);
  };
  const openFeedbackForm = () => {
    window.open("https://forms.office.com/Pages/ResponsePage.aspx?id=wvf0s85ykkGrpNbHcZtXZiTSd14A_u5NkYT6W7-McpVUN0hDRkdJSU9BSDRaWTZSUjZWRE1BM1FJMS4u", "_blank");
    trackNavigation("feedback_form");
  };
  return <div className="w-50 flex-shrink-0 space-y-8 bg-[#000835] rounded-xl p-4 text-white">
      <Link to="/" onClick={() => handleNavClick("home_logo")} className="block flex flex-col items-center gap-2 px-[50px]">
        <span className="text-xs font-semibold text-white text-center">{HeyUtils.getInstance().getConfig().clientDisplayName}</span>
        <img src={HeyUtils.getInstance().getConfig().clientLogoUrl} alt="Travel App" className="w-20 h-20 hover:opacity-90 transition-opacity" />
      </Link>

      <nav className="space-y-2">
        <Link to="/" className={`flex items-center space-x-3 px-4 py-2 rounded-lg transition-colors ${isActive('/') ? 'bg-white/10 text-white' : 'text-gray-400 hover:bg-white/5'}`} onClick={() => handleNavClick("home")}>
          <Globe className="w-5 h-5" />
          <span>{t("sidebar.myTrips", "My Trips")}</span>
        </Link>
        
        <Link to="/new-trip" className={`flex items-center space-x-3 px-4 py-2 rounded-lg transition-colors ${isActive('/new-trip') ? 'bg-white/10 text-white' : 'text-gray-400 hover:bg-white/5'}`} onClick={() => handleNavClick("new_trip")}>
          <PlusSquare className="w-5 h-5" />
          <span>{t("sidebar.newTrip", "New Trip")}</span>
        </Link>
        
        <Link to="/discover" className={`flex items-center space-x-3 px-4 py-2 rounded-lg transition-colors ${isActive('/discover') ? 'bg-white/10 text-white' : 'text-gray-400 hover:bg-white/5'}`} onClick={() => handleNavClick("discover")}>
          <Compass className="w-5 h-5" />
          <span>{t("sidebar.discover", "Discover")}</span>
        </Link>

        <Link to="/profile" className={`flex items-center space-x-3 px-4 py-2 rounded-lg transition-colors ${isActive('/profile') ? 'bg-white/10 text-white' : 'text-gray-400 hover:bg-white/5'}`} onClick={() => handleNavClick("profile")}>
          <User className="w-5 h-5" />
          <span>{t("sidebar.profile", "Profile")}</span>
        </Link>

        <button onClick={handleSignOut} className="flex items-center space-x-3 px-4 py-2 rounded-lg transition-colors w-full text-left text-gray-400 hover:bg-white/5">
          <LogOut className="w-5 h-5" />
          <span>{t("auth.signOut", "Logout")}</span>
        </button>
      </nav>

      <div className="mt-auto pt-4 border-t border-white/10">
        <Button onClick={openFeedbackForm} className="w-full flex items-center justify-center gap-2 py-[14px] text-slate-400 bg-indigo-950 hover:bg-indigo-800 my-[25px]">
          <MessageCircle className="w-5 h-5" />
          <span>{t("sidebar.feedback", "Feedback")}</span>
        </Button>
      </div>
    </div>;
};
export default DesktopSidebar;